import React from "react";
import { motion } from "framer-motion";
import { FC, ReactNode } from "react";

interface AnimatedContainerProps {
  children: ReactNode;
  hoverEffect?: boolean;
  transition?: object;
  initial?: object;
  animate?: object;
}

const AnimatedContainer: FC<AnimatedContainerProps> = ({
  children,
  hoverEffect,
  initial,
  transition,
  animate
}) => {
  return (
    <motion.div
      initial={initial ? { ...initial } : { opacity: 0, scale: 0.9, y: -30 }}
      animate={animate ? { ...animate } : { opacity: 1, scale: 1, y: 0 }}
      transition={
        transition
          ? { ...transition }
          : {
              duration: 1,
              ease: [0.25, 0.4, 0.25, 1],
              scale: {
                type: "spring",
                stiffness: 100,
                damping: 15
              }
            }
      }
      whileHover={
        hoverEffect
          ? {
              scale: 1.02,
              transition: { duration: 0.3 }
            }
          : {}
      }
    >
      {children}
    </motion.div>
  );
};

export default AnimatedContainer;
